"use strict";
// Authentication-specific types for both frontend and backend
Object.defineProperty(exports, "__esModule", { value: true });
